import React from 'react';
import { connect } from 'react-redux';
import Hierarchy from 'components/Hierarchy';
import { getDefsWithParents, sortByYoungest } from './hierarchyUtils';

function HierarchyLinksContainer({ defs: d, entity }) {
  let relatedEntityTypes = ([entity, ...(entity._links || [])]).filter(
    e => e.type !== 'case'
  ).map(e => e.type);

  let defs = d.filter(def =>
    [ ...relatedEntityTypes, entity.type ].some(x => x === def.id)
  ).filter(d => d.submittable);

  let defsWithParents = getDefsWithParents({ defs });
  let hierarchy = sortByYoungest({ defsWithParents });

  let props = { entity, hierarchy,
    relatedEntities: [ entity, ...(entity._links || []).map(e => ({ [e.type]: [e] })) ]
  };

  return <Hierarchy { ...props } defs={d} />;
}

export default connect(
  state => ({ defs: state.entityDefinitions.defs })
)(HierarchyLinksContainer);
